module.exports = __webpack_public_path__ + "img/symbol-t-right.ab6a6333.png";